/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var WorkflowDrawingInstance = /** @class */ (function () {
            function WorkflowDrawingInstance(svgElementId, service, drawingService, settings, pageScope, rootScope, statusFlowChangedCallback, workflowUpdatedCallback, modalService) {
                var _this = this;
                this.logType = "WorkflowDrawingInstance";
                this.typesComplete = [
                    4 /* StatusChange */,
                    1 /* UserAction */,
                    3 /* Message */,
                    98 /* Goto */,
                    7 /* CreatePdfAction */,
                    19 /* Copy */,
                    20 /* SetData */,
                    21 /* AssignClaim */,
                    8 /* SendEmailAction */,
                    0 /* State */,
                    2 /* Condition */,
                    6 /* Validate */,
                    9 /* CalculateAction */,
                    11 /* BookResource */,
                    12 /* RemoveResource */,
                    13 /* ProcessAction */,
                    17 /* SystemAction */,
                    16 /* ReturnFromProcessAction */,
                    15 /* StartProcessAction */,
                    14 /* ChangeState */,
                    18 /* GotoState */
                ];
                this.service = service;
                this.drawingService = drawingService;
                this.statusFlowChangedCallback = statusFlowChangedCallback;
                this.workflowUpdatedCallback = workflowUpdatedCallback;
                this.modalService = modalService;
                this.svgElementId = svgElementId;
                this.paper = Snap('#' + svgElementId);
                if (this.paper === undefined || this.paper === null) {
                    alert("What what!");
                }
                this.settings = settings;
                this.blockLocations = [];
                this.events = new models.WorkflowEvents(this, pageScope, this.drawingService);
                var cb = rootScope.$on("re-draw-workflow", function (event) {
                    _this.reDraw();
                });
                //destroy the listener on scope destroy to avoid memory leak
                pageScope.$on("$destroy", function () {
                    cb();
                });
            }
            WorkflowDrawingInstance.prototype.initializeData = function (processConfigId, isReadonly, processActionId) {
                this.processConfigId = processConfigId;
                this.processActionId = processActionId;
                this.isReadonly = isReadonly;
            };
            WorkflowDrawingInstance.prototype.drawModel = function (initialBlock) {
                this.removeAllDropZones();
                this.removeAllGotoBlocks();
                this.clear();
                this.paper.attr({ opacity: 0 });
                // All lines will be appended to this group so that they will appear first in the DOM and therefore be below the shapes and not interfere with the hover targets
                this.lines = this.paper.group();
                // Feedback lines need to appear on top of the lines but underneath the shapes.
                this.feedbackLines = this.paper.group();
                if (!this.isReadonly)
                    this.addDropZones(initialBlock);
                return this.drawingService.drawModel(this, initialBlock);
            };
            WorkflowDrawingInstance.prototype.configureWorkflowBlock = function (workflowBlock) {
                var _this = this;
                switch (workflowBlock.type) {
                    case 4 /* StatusChange */:
                        var statusChangeBlock = workflowBlock;
                        this.service.getStatusChangeDto(statusChangeBlock.statusChangeId)
                            .then(function (dto) {
                            statusChangeBlock.populateDto(dto);
                            _this.showStatusChangeModal(statusChangeBlock);
                        });
                        break;
                    case 1 /* UserAction */:
                        var userActionBlock = workflowBlock;
                        this.service.getUserActionDto(userActionBlock.id)
                            .then(function (dto) {
                            userActionBlock.populateDto(dto);
                            _this.showUserActionModal(userActionBlock);
                        });
                        break;
                    case 3 /* Message */:
                        var messageWorkflowBlock = workflowBlock;
                        this.service.getMessageDto(messageWorkflowBlock.id)
                            .then(function (dto) {
                            messageWorkflowBlock.populateDto(dto);
                            _this.showMessageModal(messageWorkflowBlock);
                        });
                        break;
                    case 98 /* Goto */:
                        var gotoWorkflowBlock = workflowBlock;
                        var validToTypes = models.WorkflowBlockManager.getValidToBlockTypes(98 /* Goto */);
                        var validToBlocks = Enumerable.from(this.blockLocations)
                            .select(function (i) { return i.workflowBlock; })
                            .where(function (i) { return validToTypes.indexOf(i.type) !== -1; })
                            .toArray();
                        this.showGotoModal(gotoWorkflowBlock, validToBlocks);
                        break;
                    case 7 /* CreatePdfAction */:
                        var createPdfWorkflowBlock = workflowBlock;
                        this.service.getCreatePdfDto(createPdfWorkflowBlock.id)
                            .then(function (dto) {
                            createPdfWorkflowBlock.populateDto(dto);
                            _this.showCreatePdfModal(createPdfWorkflowBlock);
                        });
                        break;
                    case 19 /* Copy */:
                        var copyWorkflowBlock = workflowBlock;
                        this.service.getCopyDto(copyWorkflowBlock.id)
                            .then(function (dto) {
                            copyWorkflowBlock.populateDto(dto);
                            _this.showCopyModal(copyWorkflowBlock);
                        });
                        break;
                    case 20 /* SetData */:
                        var setDataWorkflowBlock = workflowBlock;
                        this.service.getSetDataDto(setDataWorkflowBlock.id)
                            .then(function (dto) {
                            setDataWorkflowBlock.populateDto(dto);
                            _this.showSetDataModal(setDataWorkflowBlock);
                        });
                        break;
                    case 21 /* AssignClaim */:
                        var assignClaimWorkflowBlock = workflowBlock;
                        this.service.getAssignClaimDto(assignClaimWorkflowBlock.id)
                            .then(function (dto) {
                            assignClaimWorkflowBlock.populateDto(dto);
                            _this.showAssignClaimModal(assignClaimWorkflowBlock);
                        });
                        break;
                    case 8 /* SendEmailAction */:
                        var sendEmailWorkflowBlock = workflowBlock;
                        this.service.getSendEmailDto(sendEmailWorkflowBlock.id)
                            .then(function (dto) {
                            sendEmailWorkflowBlock.populateDto(dto);
                            _this.showSendEmailModal(sendEmailWorkflowBlock);
                        });
                        break;
                    case 0 /* State */:
                        var stateWorkflowBlock = workflowBlock;
                        this.service.getStateDto(stateWorkflowBlock.id)
                            .then(function (dto) {
                            stateWorkflowBlock.populateDto(dto);
                            _this.showStateModal(stateWorkflowBlock);
                        });
                        break;
                    case 2 /* Condition */:
                        var conditionWorkflowBlock = workflowBlock;
                        this.service.getConditionDto(conditionWorkflowBlock.id)
                            .then(function (dto) {
                            conditionWorkflowBlock.populateDto(dto);
                            _this.showConditionModal(conditionWorkflowBlock);
                        });
                        break;
                    case 6 /* Validate */:
                        var validateBlock = workflowBlock;
                        this.service.getValidateDto(validateBlock.id)
                            .then(function (dto) {
                            validateBlock.populateDto(dto);
                            _this.showValidateModal(validateBlock);
                        });
                        break;
                    case 9 /* CalculateAction */:
                        var calculateBlock = workflowBlock;
                        this.service.getCalculateDto(calculateBlock.id)
                            .then(function (dto) {
                            calculateBlock.populateDto(dto);
                            _this.showCalculateModal(calculateBlock);
                        });
                        break;
                    case 11 /* BookResource */:
                        var bookResourceBlock = workflowBlock;
                        this.service.getBookResourceDto(bookResourceBlock.id)
                            .then(function (dto) {
                            bookResourceBlock.populateDto(dto);
                            _this.showBookResourceModal(bookResourceBlock);
                        });
                        break;
                    case 12 /* RemoveResource */:
                        var removeResourceBlock = workflowBlock;
                        this.service.getRemoveResourceDto(removeResourceBlock.id)
                            .then(function (dto) {
                            removeResourceBlock.populateDto(dto);
                            _this.showRemoveResourceModal(removeResourceBlock);
                        });
                        break;
                    case 16 /* ReturnFromProcessAction */:
                        var returnFromProcessActionBlock = workflowBlock;
                        this.service.getReturnFromProcessActionDto(returnFromProcessActionBlock.id)
                            .then(function (dto) {
                            returnFromProcessActionBlock.populateDto(dto);
                            _this.showReturnFromProcessActionModal(returnFromProcessActionBlock);
                        });
                        break;
                    case 13 /* ProcessAction */:
                        var processActionBlock = workflowBlock;
                        this.service.getProcessActionDto(processActionBlock.id)
                            .then(function (dto) {
                            processActionBlock.populateDto(dto);
                            _this.showProcessActionModal(processActionBlock);
                        });
                        break;
                    case 17 /* SystemAction */:
                        var systemActionBlock = workflowBlock;
                        this.service.getSystemActionDto(systemActionBlock.id)
                            .then(function (dto) {
                            systemActionBlock.populateDto(dto);
                            _this.showSystemActionModal(systemActionBlock);
                        });
                        break;
                    case 14 /* ChangeState */:
                        var changeStateBlock = workflowBlock;
                        this.service.getChangeStateDto(changeStateBlock.id)
                            .then(function (dto) {
                            changeStateBlock.populateDto(dto);
                            _this.showChangeStateActionModal(changeStateBlock);
                        });
                        break;
                    case 18 /* GotoState */:
                        var gotoStateBlock = workflowBlock;
                        this.service.getGotoStateDto(gotoStateBlock.id)
                            .then(function (dto) {
                            gotoStateBlock.populateDto(dto);
                            _this.showGotoStateActionModal(gotoStateBlock);
                        });
                        break;
                    default:
                        alert("In-Work");
                }
            };
            WorkflowDrawingInstance.prototype.removeWorkflowBlockFromWorkflow = function (workflowBlock) {
                var _this = this;
                var fromBlock = workflowBlock.getFromWorkflowBlocks()[0];
                var gotoBlockToBlockId = undefined;
                var isGotoBlock = workflowBlock.type === 98 /* Goto */;
                if (isGotoBlock) {
                    var gotoBlock = workflowBlock;
                    if (gotoBlock.toBlock)
                        gotoBlockToBlockId = gotoBlock.toBlock.id;
                }
                this.service.deleteWorkflowBlock(workflowBlock.id, fromBlock.id, isGotoBlock, gotoBlockToBlockId).then(function () { return _this.removeWorkflowBlockFromDrawing(workflowBlock); }, function () { return alert("Delete was not successful"); });
            };
            WorkflowDrawingInstance.prototype.reDraw = function () {
                if (this.workflowUpdatedCallback)
                    this.workflowUpdatedCallback();
                this.drawModel(this.blockLocations[0].workflowBlock);
                this.service.addOrRemoveFeedbackArrowLines();
            };
            WorkflowDrawingInstance.prototype.getWorkFlowBlockById = function (id) {
                if (!id)
                    return undefined;
                return Enumerable.from(this.blockLocations).singleOrDefault(function (i) { return i.workflowBlock.id === id; }).workflowBlock;
            };
            WorkflowDrawingInstance.prototype.droppedNewShapeOnDropZone = function (type, dropZoneWorkflowBlock) {
                var _this = this;
                var self = this;
                var validChoice = this.canShapeBeDropped(type, dropZoneWorkflowBlock);
                if (!validChoice) {
                    this.unHighlightAllDropZones();
                    return;
                }
                if (dropZoneWorkflowBlock.type !== 99 /* DropZone */) {
                    return;
                }
                var connections = new models.WorkflowBlockConnections(dropZoneWorkflowBlock, this.blockLocations);
                if (type === 98 /* Goto */) {
                    var newId = models.WorkflowBlockManager.initialGotoId;
                    var otherGotos = Enumerable.from(this.blockLocations)
                        .where(function (i) { return i.workflowBlock.type === 98 /* Goto */; })
                        .toArray();
                    if (otherGotos.length > 0) {
                        var currentMaxId = Enumerable.from(otherGotos)
                            .select(function (i) { return i.workflowBlock.id; })
                            .max();
                        newId = currentMaxId + 1;
                    }
                    var newGotoBlock = new models.GotoWorkflowBlock(newId.toString(), "Go To");
                    this.addNewWorkflowBlockCallback(newGotoBlock, dropZoneWorkflowBlock);
                }
                else {
                    this.service.createNewWorkflowBlock(type, this.blockLocations[0].workflowBlock.statusCodeId, this.blockLocations[0].workflowBlock.processActionId, connections.connectionDto).then(function (newWorkflowBlock) { return _this.addNewWorkflowBlockCallback(newWorkflowBlock, dropZoneWorkflowBlock); }, function () {
                        _this.unHighlightAllDropZones();
                        alert("Could not add this workflow block.");
                    });
                }
            };
            WorkflowDrawingInstance.prototype.droppedNewShapeOnInBetweenDropZone = function (type, fromWorkflowBlock, toWorkflowBlock) {
                var validChoice = this.canShapeBeDroppedInBetween(type, fromWorkflowBlock, toWorkflowBlock);
                if (!validChoice)
                    return;
                var addContext = {
                    blockType: type,
                    fromBlockId: fromWorkflowBlock.id,
                    toBlockId: toWorkflowBlock.id,
                    gotoToBlockId: undefined,
                    statusCodeId: this.blockLocations[0].workflowBlock.statusCodeId,
                    processActionId: this.blockLocations[0].workflowBlock.processActionId,
                    outputIndex: 0
                };
                var newObjectForTest = models.WorkflowBlockManager.createWorkflowBlock(type, "-13", undefined);
                if (newObjectForTest.getOutputType() === 2 /* YesNo */) {
                    this.showYesNoOutputSelectionModal(addContext);
                }
                else {
                    this.saveInBetweenWorkflowBlock(addContext);
                }
            };
            WorkflowDrawingInstance.prototype.saveInBetweenWorkflowBlock = function (addContext) {
                var _this = this;
                var toBlock = Enumerable.from(this.blockLocations)
                    .select(function (i) { return i.workflowBlock; })
                    .singleOrDefault(function (i) { return i.id == addContext.toBlockId; });
                if (toBlock && toBlock.type == 98 /* Goto */) {
                    var newToBlock = toBlock.toBlocks[0];
                    if (newToBlock) {
                        addContext.gotoToBlockId = addContext.toBlockId;
                        addContext.toBlockId = newToBlock.id;
                    }
                }
                this.service.createNewWorkflowBlockInBetween(addContext).then(function (newWorkflowBlock) { return _this.addNewWorkflowBlockInBetweenCallback(newWorkflowBlock, addContext); }, function () {
                    _this.unHighlightAllInBetweenDropZones();
                    alert("Could not add this workflow block.");
                });
            };
            WorkflowDrawingInstance.prototype.draggingNewShape = function (selectedWorkflowShape, hoverContext) {
                this.unHighlightAllDropZones();
                this.unHighlightAllInBetweenDropZones();
                if (hoverContext.workflowBlock) {
                    if (hoverContext.workflowBlock && hoverContext.workflowBlock.type === 99 /* DropZone */) {
                        var dropZone = hoverContext.workflowBlock;
                        var validChoice = this.canShapeBeDropped(selectedWorkflowShape, dropZone);
                        if (validChoice)
                            dropZone.highlightValidOption();
                        else
                            dropZone.highlightInvalidOption();
                    }
                }
                else if (hoverContext.inBetweenDropZoneHovered) {
                    var validChoice = this.canShapeBeDroppedInBetween(selectedWorkflowShape, hoverContext.inBetweenFromWorkflowBlock, hoverContext.inBetweenToWorkflowBlock);
                    if (validChoice)
                        this.inBetweenDropZones[hoverContext.inBetweenIndex].attr({ class: "in-between-drop-zone hover-valid-option", opacity: 1 });
                    else
                        this.inBetweenDropZones[hoverContext.inBetweenIndex].attr({ class: "in-between-drop-zone hover-invalid-option", opacity: 1 });
                }
            };
            WorkflowDrawingInstance.prototype.drawFeedbackArrow = function (fromWorkflowBlock, toWorkflowBlock, toggleEnabled) {
                return this.drawingService.drawFeedbackArrow(this, fromWorkflowBlock, toWorkflowBlock, toggleEnabled);
            };
            // Private Helper Methods
            // ===================================================================================================================
            WorkflowDrawingInstance.prototype.removeWorkflowBlockFromDrawing = function (workflowBlock) {
                //{ from } ----> [block to delete] ----> { to }
                //{ from } ----------------------------> { to }
                warsApp.services.WarsLogger.logInfo("Attempting to delete a Workflow block of type: " + workflowBlock.type, this.logType);
                var i;
                var fromBlock = workflowBlock.getFromWorkflowBlocks()[0];
                if (workflowBlock.type == 98 /* Goto */) {
                    for (i = 0; i < fromBlock.toBlocks.length; i++) {
                        if (fromBlock.toBlocks[i].id === workflowBlock.id) {
                            fromBlock.toBlocks.splice(i, 1);
                        }
                    }
                }
                else {
                    var allTos = Enumerable.from(workflowBlock.toBlocks).where(function (i) { return i.type !== 99 /* DropZone */; }).toArray();
                    for (i = 0; i < fromBlock.toBlocks.length; i++) {
                        if (fromBlock.toBlocks[i].id === workflowBlock.id) {
                            if (fromBlock.getOutputType() === 2 /* YesNo */) {
                                if (allTos.length > 1)
                                    throw 'Not supposed to happen';
                                fromBlock.toBlocks[i] = allTos[0];
                            }
                            else {
                                fromBlock.toBlocks.splice(i, 1);
                                var insertIndex = i;
                                for (var toIndex = 0; toIndex < allTos.length; toIndex++) {
                                    var currentToBlock = allTos[toIndex];
                                    fromBlock.toBlocks[insertIndex++] = currentToBlock;
                                }
                            }
                        }
                    }
                }
                this.reDraw();
                if (workflowBlock.type === 4 /* StatusChange */) {
                    if (this.statusFlowChangedCallback) {
                        var workflowBlocks = Enumerable.from(this.blockLocations).select(function (i) { return i.workflowBlock; }).toArray();
                        this.statusFlowChangedCallback(workflowBlocks);
                    }
                }
            };
            WorkflowDrawingInstance.prototype.addNewWorkflowBlockCallback = function (newWorkflowBlock, dropZoneWorkflowBlock) {
                newWorkflowBlock.setDrawingInstance(this);
                this.replaceDropZoneWithNewShape(newWorkflowBlock, dropZoneWorkflowBlock);
                this.reDraw();
                if (this.typesComplete.indexOf(newWorkflowBlock.type) !== -1) {
                    this.configureWorkflowBlock(newWorkflowBlock);
                }
            };
            WorkflowDrawingInstance.prototype.replaceDropZoneWithNewShape = function (newWorkflowBlock, dropZoneWorkflowBlock) {
                for (var i = 0; i < this.blockLocations.length; i++) {
                    var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                    for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                        if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].id === dropZoneWorkflowBlock.id) {
                            currentWorkflowBlock.toBlocks[x] = newWorkflowBlock;
                        }
                    }
                }
            };
            WorkflowDrawingInstance.prototype.addNewWorkflowBlockInBetweenCallback = function (newWorkflowBlock, addContext) {
                newWorkflowBlock.setDrawingInstance(this);
                var toBlockId = addContext.gotoToBlockId != undefined ? addContext.gotoToBlockId : addContext.toBlockId;
                this.insertNewShapeInBetweenWorkflowBlocks(newWorkflowBlock, addContext.fromBlockId, toBlockId, addContext.outputIndex);
                this.reDraw();
                if (this.typesComplete.indexOf(newWorkflowBlock.type) !== -1) {
                    this.configureWorkflowBlock(newWorkflowBlock);
                }
            };
            WorkflowDrawingInstance.prototype.insertNewShapeInBetweenWorkflowBlocks = function (newWorkflowBlock, fromWorkflowBlockId, toWorkflowBlockId, outputIndex) {
                for (var i = 0; i < this.blockLocations.length; i++) {
                    var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                    if (currentWorkflowBlock.id == fromWorkflowBlockId) {
                        for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                            if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].id == toWorkflowBlockId) {
                                currentWorkflowBlock.toBlocks[x] = newWorkflowBlock;
                            }
                        }
                    }
                }
                var blockLocationOfToBlock = Enumerable.from(this.blockLocations).single(function (i) { return i.workflowBlock.id == toWorkflowBlockId; });
                newWorkflowBlock.toBlocks[outputIndex] = blockLocationOfToBlock.workflowBlock;
                // Add into block locations too without a coordinate.  The drawing algorithm will redraw and update the block locations anyway.  But this is 
                //  required becase some other methods depend on the workflow blocks being in the block locations.
                this.blockLocations.push(new models.WorkflowBlockLocation(newWorkflowBlock, new models.Coordinate(0, 0)));
            };
            WorkflowDrawingInstance.prototype.removeAllDropZones = function () {
                if (!this.blockLocations || this.blockLocations.length === 0)
                    return;
                for (var i = 0; i < this.blockLocations.length; i++) {
                    var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                    if (currentWorkflowBlock.type == 99 /* DropZone */) {
                        this.blockLocations.splice(i, 1);
                        i--;
                        continue;
                    }
                    for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                        if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].type == 99 /* DropZone */) {
                            if (currentWorkflowBlock.getOutputType() == 2 /* YesNo */) {
                                currentWorkflowBlock.toBlocks[x] = undefined;
                            }
                            else {
                                currentWorkflowBlock.toBlocks.splice(x, 1);
                            }
                            x--;
                        }
                    }
                }
            };
            WorkflowDrawingInstance.prototype.removeAllGotoBlocks = function () {
                if (!this.blockLocations || this.blockLocations.length === 0)
                    return;
                for (var i = 0; i < this.blockLocations.length; i++) {
                    var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                    if (currentWorkflowBlock.type == 98 /* Goto */) {
                        var gotoBlock = currentWorkflowBlock;
                        var fromBlock = gotoBlock.getFromWorkflowBlocks()[0];
                        if (fromBlock) {
                            for (var x = 0; x < fromBlock.toBlocks.length; x++) {
                                if (fromBlock.toBlocks[x] && fromBlock.toBlocks[x].id == gotoBlock.id) {
                                    fromBlock.toBlocks[x] = gotoBlock.toBlock;
                                }
                            }
                        }
                        this.blockLocations.splice(i, 1);
                        i--;
                        continue;
                    }
                }
            };
            WorkflowDrawingInstance.prototype.addDropZones = function (initialBlock) {
                var workflowBlocksToAnalyze = [initialBlock];
                var workflowBlockIdsAlreadyAnalyzed = [];
                var currentDropZoneId = models.WorkflowBlockManager.intialDropZoneId;
                while (workflowBlocksToAnalyze.length > 0) {
                    var currentBlock = workflowBlocksToAnalyze.shift();
                    if (workflowBlockIdsAlreadyAnalyzed.indexOf(currentBlock.id) !== -1) {
                        continue;
                    }
                    workflowBlockIdsAlreadyAnalyzed.push(currentBlock.id);
                    if (currentBlock.getOutputType() == 3 /* None */) {
                        continue;
                    }
                    else if (currentBlock.getOutputType() == 2 /* YesNo */) {
                        var yesNoBlock = currentBlock;
                        if (!yesNoBlock.yesBlock) {
                            yesNoBlock.yesBlock = models.WorkflowBlockManager.createDropZone(((currentDropZoneId++).toString()).toString(), true, this);
                        }
                        else {
                            if (workflowBlockIdsAlreadyAnalyzed.indexOf(yesNoBlock.yesBlock.id) === -1) {
                                workflowBlocksToAnalyze.push(yesNoBlock.yesBlock);
                            }
                        }
                        if (!yesNoBlock.noBlock) {
                            yesNoBlock.noBlock = models.WorkflowBlockManager.createDropZone(((currentDropZoneId++).toString()).toString(), true, this);
                        }
                        else {
                            if (workflowBlockIdsAlreadyAnalyzed.indexOf(yesNoBlock.noBlock.id) === -1) {
                                workflowBlocksToAnalyze.push(yesNoBlock.noBlock);
                            }
                        }
                    }
                    else if (currentBlock.getOutputType() == 1 /* Multiple */) {
                        for (var i = 0; i < currentBlock.toBlocks.length; i++) {
                            if (workflowBlockIdsAlreadyAnalyzed.indexOf(currentBlock.toBlocks[i].id) === -1) {
                                workflowBlocksToAnalyze.push(currentBlock.toBlocks[i]);
                            }
                        }
                        var required = currentBlock.toBlocks.length == 0;
                        currentBlock.toBlocks.push(models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), required, this));
                        var onlyToBlockIsDropZone = currentBlock.toBlocks.length == 1 && currentBlock.toBlocks[0].type == 99 /* DropZone */;
                        if (required && !onlyToBlockIsDropZone) {
                            // Always adding an optional drop zone b/c states can have infinite to blocks
                            currentBlock.toBlocks.push(models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), false, this));
                        }
                    }
                    else if (currentBlock.getOutputType() == 0 /* Single */) {
                        if (currentBlock.type == 98 /* Goto */)
                            continue;
                        var singleOutputBlock = currentBlock;
                        if (!singleOutputBlock.toBlock) {
                            singleOutputBlock.toBlock = models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), true, this);
                        }
                        else {
                            if (workflowBlockIdsAlreadyAnalyzed.indexOf(singleOutputBlock.toBlock.id) === -1) {
                                workflowBlocksToAnalyze.push(singleOutputBlock.toBlock);
                            }
                        }
                    }
                    else {
                        throw 'Unknown Output Type: ' + currentBlock.getOutputType();
                    }
                }
            };
            WorkflowDrawingInstance.prototype.canShapeBeDropped = function (type, dropZone) {
                if (this.isReadonly)
                    return false;
                var fromWorkflowBlocks = dropZone.getFromWorkflowBlocks();
                var invalidChoice = Enumerable.from(fromWorkflowBlocks).any(function (i) { return !i.canConnectToWorkflowBlockType(type); });
                return !invalidChoice;
            };
            WorkflowDrawingInstance.prototype.canShapeBeDroppedInBetween = function (type, fromWorkflowBlock, toWorkflowBlock) {
                if (this.isReadonly)
                    return false;
                var newObjectForTest = models.WorkflowBlockManager.createWorkflowBlock(type, "-13", undefined);
                var fromValid = fromWorkflowBlock.canConnectToWorkflowBlockType(type);
                var toValid = newObjectForTest.canConnectToWorkflowBlockType(toWorkflowBlock.type);
                return fromValid && toValid;
            };
            WorkflowDrawingInstance.prototype.unHighlightAllDropZones = function () {
                for (var i = 0; i < this.blockLocations.length; i++) {
                    var block = this.blockLocations[i].workflowBlock;
                    if (block.type == 99 /* DropZone */) {
                        block.unHighlight();
                    }
                }
            };
            WorkflowDrawingInstance.prototype.unHighlightAllInBetweenDropZones = function () {
                if (this.inBetweenDropZones) {
                    for (var i = 0; i < this.inBetweenDropZones.length; i++) {
                        this.inBetweenDropZones[i].attr({ class: "in-between-drop-zone", opacity: 0 });
                    }
                }
            };
            WorkflowDrawingInstance.prototype.clear = function () {
                this.paper.clear();
            };
            WorkflowDrawingInstance.prototype.showStatusChangeModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.statusChangeDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_statusChangeSettingsModal.html",
                    controller: "statusChangeSettingsModalController",
                    inputs: {
                        processConfigId: this.processConfigId,
                        workflowBlock: workflowBlock,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateStatusChange(workflowBlock).then(function (workflowBlockDto) {
                                workflowBlock.label = workflowBlockDto.name;
                                workflowBlock.toStatusGroupId = workflowBlockDto.toStatusGroupId;
                                self.reDraw();
                                var blocks = Enumerable.from(self.blockLocations)
                                    .select(function (i) { return i.workflowBlock; })
                                    .where(function (i) { return i.type !== 99 /* DropZone */; })
                                    .toArray();
                                if (self.statusFlowChangedCallback != undefined) {
                                    self.statusFlowChangedCallback(blocks);
                                }
                            }, function () { return workflowBlock.statusChangeDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showUserActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.userActionDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_userActionSettingsModal.html",
                    controller: "userActionSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            workflowBlock.userActionDto.documentConfigurationId = workflowBlock.userActionDto.documentConfiguration
                                ? workflowBlock.userActionDto.documentConfiguration.id
                                : undefined;
                            self.service.updateUserAction(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.userActionDto = revertDto; });
                        }
                        else {
                            workflowBlock.userActionDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showMessageModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.messageDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_messageSettingsModal.html",
                    controller: "messageSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateMessage(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.messageDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showGotoModal = function (workflowBlock, validToBlocks) {
                var self = this;
                var blockBeforeGoto = workflowBlock.getFromWorkflowBlocks()[0];
                if (!blockBeforeGoto)
                    throw 'Could not find the block before the goto block';
                var filteredValidToBlocks;
                if (blockBeforeGoto.type === 0 /* State */) {
                    filteredValidToBlocks = Enumerable.from(validToBlocks)
                        .where(function (i) { return i.type === 1 /* UserAction */ || i.type === 13 /* ProcessAction */; })
                        .toArray();
                }
                else {
                    filteredValidToBlocks = Enumerable.from(validToBlocks)
                        .where(function (i) { return i.type !== 1 /* UserAction */; })
                        .toArray();
                }
                var multiOutputIndex;
                for (multiOutputIndex = 0; multiOutputIndex < blockBeforeGoto.toBlocks.length; multiOutputIndex++) {
                    if (blockBeforeGoto.toBlocks && blockBeforeGoto.toBlocks.length > multiOutputIndex && blockBeforeGoto.toBlocks[multiOutputIndex].id === workflowBlock.id)
                        break;
                }
                var model = new models.GotoSettingsModel(workflowBlock, filteredValidToBlocks);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_gotoSettingsModal.html",
                    controller: "gotoSettingsModalController",
                    inputs: {
                        model: model,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            model.workflowBlock.toBlock = model.toBlock;
                            var isTo = false;
                            var isYes = false;
                            var isNo = false;
                            if (blockBeforeGoto.getOutputType() === 0 /* Single */) {
                                isTo = true;
                            }
                            else if (blockBeforeGoto.getOutputType() === 2 /* YesNo */) {
                                var yesNoBeforeBlock = blockBeforeGoto;
                                isYes = yesNoBeforeBlock.yesBlock && yesNoBeforeBlock.yesBlock.id === workflowBlock.id;
                                isNo = yesNoBeforeBlock.noBlock && yesNoBeforeBlock.noBlock.id === workflowBlock.id;
                            }
                            self.service.updateGotoBlock(blockBeforeGoto, model.toBlock, isTo, isYes, isNo, multiOutputIndex).then(function () {
                                self.reDraw();
                            });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showCreatePdfModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.createPdfDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_createPdfSettingsModal.html",
                    controller: "createPdfSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateCreatePdf(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.createPdfDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showCopyModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.copyDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_copySettingsModal.html",
                    controller: "copySettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateCopy(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.copyDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showSetDataModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.setDataDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_setDataSettingsModal.html",
                    controller: "setDataSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateSetData(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.setDataDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showAssignClaimModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.assignClaimDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_assignClaimSettingsModal.html",
                    controller: "assignClaimSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateAssignClaim(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.assignClaimDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showSendEmailModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.sendEmailDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_sendEmailSettingsModal.html",
                    controller: "sendEmailSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateSendEmail(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.sendEmailDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showStateModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.stateDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_stateSettingsModal.html",
                    controller: "stateSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateState(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.stateDto = revertDto; });
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showConditionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.conditionDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_conditionSettingsModal.html",
                    controller: "conditionSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateCondition(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.conditionDto = revertDto; });
                        }
                        else {
                            workflowBlock.conditionDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showValidateModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.validateDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_validateSettingsModal.html",
                    controller: "validateSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateValidate(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.validateDto = revertDto; });
                        }
                        else {
                            workflowBlock.validateDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showCalculateModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.calculateDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_calculateSettingsModal.html",
                    controller: "calculateSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateCalculate(workflowBlock).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.calculateDto = revertDto; });
                        }
                        else {
                            workflowBlock.calculateDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showBookResourceModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.scheduledResourceDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_bookResourceSettingsModal.html",
                    controller: "bookResourceSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateScheduledResource(workflowBlock.id, workflowBlock.scheduledResourceDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.scheduledResourceDto = revertDto; });
                        }
                        else {
                            workflowBlock.scheduledResourceDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showRemoveResourceModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.scheduledResourceDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_removeResourceSettingsModal.html",
                    controller: "removeResourceSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateScheduledResource(workflowBlock.id, workflowBlock.scheduledResourceDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.scheduledResourceDto = revertDto; });
                        }
                        else {
                            workflowBlock.scheduledResourceDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showReturnFromProcessActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.returnFromProcessActionDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_returnFromProcessActionSettingsModal.html",
                    controller: "returnFromProcessActionSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateReturnFromProcessAction(workflowBlock.id, workflowBlock.returnFromProcessActionDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.returnFromProcessActionDto = revertDto; });
                        }
                        else {
                            workflowBlock.returnFromProcessActionDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showProcessActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.processActionDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_processActionSettingsModal.html",
                    controller: "processActionSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        processActionId: this.processActionId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateProcessAction(workflowBlock.id, workflowBlock.processActionDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.processActionDto = revertDto; });
                        }
                        else {
                            workflowBlock.processActionDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showSystemActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.systemActionDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_systemActionSettingsModal.html",
                    controller: "systemActionSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        processActionId: this.processActionId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateSystemAction(workflowBlock.id, workflowBlock.systemActionDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.systemActionDto = revertDto; });
                        }
                        else {
                            workflowBlock.systemActionDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showChangeStateActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.changeStateDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_changeStateSettingsModal.html",
                    controller: "changeStateSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateChangeState(workflowBlock.id, workflowBlock.changeStateDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.changeStateDto = revertDto; });
                        }
                        else {
                            workflowBlock.changeStateDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showGotoStateActionModal = function (workflowBlock) {
                var self = this;
                var revertDto = angular.copy(workflowBlock.gotoStateDto);
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_gotoStateSettingsModal.html",
                    controller: "gotoStateSettingsModalController",
                    inputs: {
                        workflowBlock: workflowBlock,
                        processConfigId: this.processConfigId,
                        isReadonly: this.isReadonly
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.service.updateGotoState(workflowBlock.id, workflowBlock.gotoStateDto).then(function (name) {
                                workflowBlock.label = name;
                                self.reDraw();
                            }, function () { return workflowBlock.gotoStateDto = revertDto; });
                        }
                        else {
                            workflowBlock.gotoStateDto = revertDto;
                        }
                    });
                });
            };
            WorkflowDrawingInstance.prototype.showYesNoOutputSelectionModal = function (addContext) {
                var self = this;
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/workflow/_yesNoOutputSelectionModal.html",
                    controller: "yesNoOutputSelectionModalController",
                    inputs: {
                        addContext: addContext
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.saveInBetweenWorkflowBlock(addContext);
                        }
                        else {
                            self.unHighlightAllInBetweenDropZones();
                        }
                    });
                });
            };
            return WorkflowDrawingInstance;
        }());
        models.WorkflowDrawingInstance = WorkflowDrawingInstance;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
